function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 117.01 127.08",
    width: "118px",
    height: "128px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-faqs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Landing-Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Donor-Portal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "58.76 9.84 17.7 26.85 0.54 67.84 17.02 109.57 58.42 126.54 99.32 108.31 116.47 67.34 100.18 26.82 58.76 9.84",
    style: {
      fill: "none",
      stroke: "#ffd100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-Copy",
    points: "58.76 0.54 17.7 17.55 0.54 58.54 17.02 100.27 58.42 117.24 99.32 99.01 116.47 58.04 100.18 17.51 58.76 0.54",
    style: {
      fill: "none",
      stroke: "#c3d7ee"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    d: "M56.16,63a1,1,0,0,1,0,2H43.84a1,1,0,0,1,0-2Zm2.09,9.45a.86.86,0,0,1,0,1.72H43.5a.86.86,0,0,1,0-1.72Zm4,.25a.88.88,0,0,1,.25.61.86.86,0,0,1-1.46.61.87.87,0,0,1-.26-.61A.89.89,0,0,1,61,72.7a.86.86,0,0,1,1.21,0Zm-.61-5.06a.86.86,0,0,1,0,1.72H43.5a.86.86,0,0,1,0-1.72ZM69.27,59a.86.86,0,0,1-.61,1.47.88.88,0,0,1-.61-.25.87.87,0,0,1,0-1.22.88.88,0,0,1,.61-.25A.86.86,0,0,1,69.27,59Zm3-8.58a3.62,3.62,0,0,1-2.77,3.8v2a.86.86,0,0,1-1.72,0V54.13a1.64,1.64,0,0,1,1.28-1.6,1.92,1.92,0,0,0-.28-3.79,2,2,0,0,0-1.45.52,1.89,1.89,0,0,0-.61,1.4.86.86,0,1,1-1.72,0A3.67,3.67,0,0,1,66.18,48a3.64,3.64,0,0,1,6.11,2.4ZM69.51,41A12.5,12.5,0,0,1,82,53.49a12.38,12.38,0,0,1-1.36,5.67,12.71,12.71,0,0,1-3.28,4.05v5a.85.85,0,0,1-.53.79.78.78,0,0,1-.33.07.9.9,0,0,1-.61-.25l-3.21-3.22a12.53,12.53,0,0,1-3.17.41H67.33a12.49,12.49,0,1,1,0-25ZM76,62.1a10.77,10.77,0,0,0-6.47-19.38H67.33a10.77,10.77,0,1,0,0,21.54h2.18a11,11,0,0,0,3.17-.47.73.73,0,0,1,.25,0,.9.9,0,0,1,.61.25l2.1,2.1V62.79A.88.88,0,0,1,76,62.1Zm-8.25,6.31a.86.86,0,0,1,.86.86V75.2a6,6,0,0,1-6,6H54.16v2.92a.85.85,0,0,1-.53.79.78.78,0,0,1-.33.07.86.86,0,0,1-.61-.25l-3.53-3.53H44a6,6,0,0,1-6-6V62a6,6,0,0,1,6-6H52.7a.86.86,0,0,1,0,1.72H44a4.31,4.31,0,0,0-4.3,4.3V75.2A4.31,4.31,0,0,0,44,79.5H49.6a.86.86,0,0,1,.79.52l2,2V80.36a.86.86,0,0,1,.86-.86h9.28a4.31,4.31,0,0,0,4.3-4.3V69.27A.86.86,0,0,1,67.73,68.41Z",
    transform: "translate(-0.46 -0.46)",
    style: {
      fill: "#2774ae"
    }
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFaqs);
export default __webpack_public_path__ + "static/media/icon-faqs.435432b6b978cb8635be20c9394a1c19.svg";
export { ForwardRef as ReactComponent };